export const DEFAULT_ROUNDING_STEP = 300;

export const ROUNDING_OPTIONS: { value: number; label: string }[] = [
  { value: 1, label: 'Exact (pas d’arrondi)' },
  { value: 5, label: '5 s' },
  { value: 10, label: '10 s' },
  { value: 15, label: '15 s' },
  { value: 30, label: '30 s' },
  { value: 60, label: '1 min' },
  { value: 300, label: '5 min' },
  { value: 600, label: '10 min' },
];

export const roundingLabel = (step: number): string =>
  ROUNDING_OPTIONS.find((o) => o.value === step)?.label ?? `${step} s`;
